module.exports = __webpack_public_path__ + "static/media/YF80_6.0ae322d4.jpg";